module.exports = __webpack_public_path__ + "static/media/notFound_icon.1287e0da.svg";